<template>
  <a-card :bordered='false' :bodyStyle='{paddingTop:"0px"}'>
    <a-tabs>
      <a-tab-pane :key="1" tab="门店导购">
        <Storescan></Storescan>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="经销商导购">
        <Dealerscan></Dealerscan>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import Storescan from "./Storescan.vue";
import Dealerscan from "./Dealerscan.vue";

export default {
  components: { 
    Storescan, 
    Dealerscan
    },
  setup() {},
};
</script>